/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { UpsellStatsSite, UpsellStatsSiteApiSubType } from "~/features/statistics/types";

const transformToUpsellStatsSite = (site: UpsellStatsSiteApiSubType): UpsellStatsSite => ({
  ...site,
  sitedomain: "",
});

export default transformToUpsellStatsSite;
